import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';

import { PacoteCampanhaCountLabelPipe } from './pacote-campanha-count-label.pipe';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        PacoteCampanhaCountLabelPipe
    ],
    exports: [
        PacoteCampanhaCountLabelPipe
    ],
    providers: [
        PacoteCampanhaCountLabelPipe
    ]
})
export class PacoteCampanhaPipeModule { }
